module.exports = __webpack_public_path__ + "media/coin-flip.d71b6efe.mp3";